import validator from "validator";

const validate = (formValues) => {
  const errors = {};

  if (!formValues.email) {
    //Email is empty
    errors.email = "signIn.errors.emailEmpty";
  }
  if (!validator.isEmail(String(formValues.email))) {
    //Email is invalid
    errors.email = "signIn.errors.emailInvalid";
  }

  if (!formValues.password) {
    //Password is empty
    errors.password = "signIn.errors.passwordEmpty";
  }

  return errors;
};

export default validate;
